var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"main"},[_c('div',{staticClass:"content_page_title"},[_c('h1',{attrs:{"id":"confirmationMail"}},[_vm._v("Validation du compte en cours.")])]),_c('div',{staticClass:"main_content"}),_c('div',{attrs:{"id":"scrollTo"}})])
}]

export { render, staticRenderFns }